import React from "react";
import { SearchResponse } from "~/models/search-result";

// eventually this should be pulled dynamically from the environment
const AUTOCOMPLETE_SEARCH_EVENT = "autocomplete-search";

export function useSearchQuery(url: string, searchTerm: string) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [hasError, setHasError] = React.useState<boolean>(false);
  const [searchData, setSearchData] = React.useState<SearchResponse>({
    data: {
      searchAutocomplete: [],
    },
  });

  // On search term change
  React.useEffect(() => {
    setLoading(true);

    // Trigger custom event for analytics
    if (searchTerm) {
      // Create custom event
      const event = new CustomEvent(AUTOCOMPLETE_SEARCH_EVENT, {
        detail: {
          name: searchTerm,
        },
      });

      // Trigger custom event
      document.dispatchEvent(event);
    }

    const controller = new AbortController();

    fetch(url, {
      signal: controller.signal,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `
            query SearchQuery {
              searchAutocomplete(term: "${searchTerm}") {
                title
                results {
                  ein
                  title
                  url
                }
              }
            }
          `,
      }),
    })
      .then((res) => res.json())
      .then((data: SearchResponse) => {
        setSearchData(data);
        setHasError(false);
        setLoading(false);
      })
      .catch((/*e: any*/) => {
        setSearchData({} as SearchResponse);
        setHasError(true);
        setLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [searchTerm]);

  return { loading, hasError, searchData };
}
